import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import { outlet } from 'lit-element-router';

@customElement('main-configurator')
export class MainConfigurator extends outlet(LitElement) {
	static styles = [
		css`
		  :host {
			height: 100%;
			display:flex;
			flex-direction: column;
		  }
		`
	];
	render() {
		return html`
			<slot></slot>
		`;
	}
}
